<template>
  <div>
    <van-nav-bar :title="$t('descriptions.pwdModify')" left-arrow @click-left="$router.back()" />
    <van-field
      v-model="password.old_password"
      rows="1"
      :autosize="true"
      type="password"
      :placeholder="$t('form.accountSecure.field.orginPassword.placeholder')"
    />
    <van-field
      v-model="password.new_password"
      rows="1"
      :autosize="true"
      type="password"
      :placeholder="$t('form.accountSecure.field.newPassword.placeholder')"
    />
    <van-field
      v-model="password.confirm_password"
      rows="1"
      :autosize="true"
      type="password"
      :placeholder="$t('form.accountSecure.field.confirmPassword.placeholder')"
    />
    <div class="submit">
      <a-button @click="handleCommit" type="primary" block>{{$t('actionTitles.submit')}}</a-button>
    </div>
  </div>
</template>

<script>
import { updatePassword } from "@/api/user";
import Vue from "vue";
import {
  Cell,
  CellGroup,
  NavBar,
  RadioGroup,
  Radio,
  Dialog,
  Field,
  Toast,
} from "vant";
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(NavBar);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Dialog);
Vue.use(Field);
Vue.use(Toast);

export default {
  data() {
    return {
      password: {
        old_password: null,
        new_password: null,
        confirm_password: null,
      },
    };
  },
  methods: {
    handleCommit() {
      if(this.password.old_password === "" || this.password.new_password === "" || this.password.confirm_password === "") {
        this.$message.error(this.$t('message.completeMessage'));
        return;
      }
      if(this.password.new_password.length < 6) {
        this.$message.error(this.$t('form.accountSecure.field.newPassword.lengthMessage'));
        return;
      }
      if(this.password.new_password !== this.password.confirm_password) {
        this.$message.error(this.$t('form.accountSecure.field.confirmPassword.inconformityMessage'));
        return;
      }
      updatePassword(this.password).then(res=>{
        this.$message.success(this.$t('message.modifySuccess'));
        this.$store.dispatch("logout")
      })
    },
  }
};
</script>

<style lang="less" scoped>
.submit {
  margin: 16px
}
</style>